import React from "react";
import umbraStaff from "../images/umbra-staff.png";

export default () => (
  <section id="credits" className="container credits-container white-text">
    <h3 className="section-title center">Credits</h3>
    <p>
      Hail and Well Met travelers! This website wouldn’t be possible without The
      Adventure Zone podcast, created by Griffin, Justin, Travis, and Clint
      McElroy, and the amazing TAZ fan art and other content that’s been spread
      across the internet. This website is solely for fun and is in no way
      affiliated with the show or books. I’ve done my best to give credit where
      it’s due but please reach out to me (
      <a href="mailto:jesse.sessler@gmail.com">jesse.sessler@gmail.com</a>) if
      you feel something has been misattributed, or you’d like your work
      removed.
    </p>

    <p>
      <b>Content</b>
    </p>

    <p>
      The Adventure Zone Podcast by Justin, Travis, Griffin, and Clint McElroy
      <br />
      <em>
        <a href="https://www.themcelroy.family/">
          https://www.themcelroy.family/
        </a>
      </em>
      <br />
      <em>
        <a href="https://www.maximumfun.org/shows/adventure-zone">
          https://www.maximumfun.org/shows/adventure-zone
        </a>
      </em>
    </p>

    <p>
      The Adventure Zone Wiki by Fandom
      <br />
      <em>
        <a href="https://theadventurezone.fandom.com/wiki/The_Adventure_Zone_Wiki">
          https://theadventurezone.fandom.com/wiki/The_Adventure_Zone_Wiki
        </a>
      </em>
    </p>

    <p>
      <b>Art</b>
    </p>

    <p>
      UI/UX Design inspired by Lily Lapidese
      <br />
      <em>
        <a href="http://lilylapidese.com/bob">http://lilylapidese.com/bob</a>
      </em>
    </p>

    <p>
      Magnus, Taako, Merle by Carey Pietsch (from the graphic novel)
      <br />
      <em>
        <a href="https://read.macmillan.com/the-adventure-zone/">
          https://read.macmillan.com/the-adventure-zone/
        </a>
      </em>
    </p>

    <p>
      Voidfish by Khroma
      <br />
      <em>
        <a href="https://khroma.tumblr.com/post/155710695759/this-podcast-sure-has-got-me-drawing">
          https://khroma.tumblr.com/post/155710695759/this-podcast-sure-has-got-me-drawing
        </a>
      </em>
    </p>

    <p>
      Lucretia by Immortanjill
      <br />
      <em>
        <a href="https://www.reddit.com/r/TheAdventureZone/comments/6od4bn/madam_director/">
          https://www.reddit.com/r/TheAdventureZone/comments/6od4bn/madam_director/
        </a>
      </em>
    </p>

    <p>
      Davenport by Doctor-mental
      <br />
      <em>
        <a href="https://www.deviantart.com/doctor-mental/art/Davenport-TAZ-763000368">
          https://www.deviantart.com/doctor-mental/art/Davenport-TAZ-763000368
        </a>
      </em>
    </p>

    <p>
      Johann by TsukiKuro23
      <br />
      <em>
        <a href="https://imgur.com/gallery/hwT5L">
          https://imgur.com/gallery/hwT5L
        </a>
      </em>
    </p>

    <p>
      Lup by Wilkoak
      <br />
      <em>
        <a href="https://wilkoakdraws.tumblr.com/post/172564713476/finished-the-design-for-my-lup-cosplay">
          https://wilkoakdraws.tumblr.com/post/172564713476/finished-the-design-for-my-lup-cosplay
        </a>
      </em>
    </p>

    <p>
      Barry by Foxaes
      <br />
      <em>
        <a href="https://theadventurezone.fandom.com/wiki/Barry_Bluejeans?file=Barry_by_Foxaes.png">
          https://theadventurezone.fandom.com/wiki/Barry_Bluejeans?file=Barry_by_Foxaes.png
        </a>
      </em>
    </p>

    <p>
      Killian by Weaselbusiness
      <br />
      <em>
        <a href="https://weaselbusiness.tumblr.com/post/151483875058/so-like-whens-the-killin-it-with-killian-spin">
          https://weaselbusiness.tumblr.com/post/151483875058/so-like-whens-the-killin-it-with-killian-spin
        </a>
      </em>
    </p>

    <p>
      Carey by Becpng
      <br />
      <em>
        <a href="https://becpng.tumblr.com/post/163765201264/how-had-i-never-drawn-carey-before-i-love-her">
          https://becpng.tumblr.com/post/163765201264/how-had-i-never-drawn-carey-before-i-love-her
        </a>
      </em>
    </p>

    <p>
      Angus by Larndraws
      <br />
      <em>
        <a href="https://larndraws.tumblr.com/post/156512452543/i-love-this-good-detective-boy">
          https://larndraws.tumblr.com/post/156512452543/i-love-this-good-detective-boy
        </a>
      </em>
    </p>

    <p>
      Lucas by Queenoftheantz
      <br />
      <em>
        <a href="https://queenoftheantz.tumblr.com/post/164002823609/i-made-a-taz-lineup-of-course-im-missing-some">
          https://queenoftheantz.tumblr.com/post/164002823609/i-made-a-taz-lineup-of-course-im-missing-some
        </a>
      </em>
    </p>

    <p>
      Avi by Spacecadetmaya
      <br />
      <em>
        <a href="https://ango-mcdonald.tumblr.com/post/157590685726/space-cadet-maya-super-quick-avi-warm-up">
          https://ango-mcdonald.tumblr.com/post/157590685726/space-cadet-maya-super-quick-avi-warm-up
        </a>
      </em>
    </p>

    <p>
      Leon by Joltzen-art
      <br />
      <em>
        <a href="https://joltzen-art.tumblr.com/post/166211499266/meet-the-bob">
          https://joltzen-art.tumblr.com/post/166211499266/meet-the-bob
        </a>
      </em>
    </p>

    <p>
      No-3113 by Swoletergeist
      <br />
      <em>
        <a href="https://swoletergeist.tumblr.com/post/155870417262/not-sure-im-gonna-finish-drawing-the-rest-of-the">
          https://swoletergeist.tumblr.com/post/155870417262/not-sure-im-gonna-finish-drawing-the-rest-of-the
        </a>
      </em>
    </p>

    <p>
      Umbra Staff by GreeNuu
      <br />
      <em>
        <a href="https://www.reddit.com/r/TheAdventureZone/comments/66yzsl/umbra_staff_tattoo_design/">
          https://www.reddit.com/r/TheAdventureZone/comments/66yzsl/umbra_staff_tattoo_design/
        </a>
      </em>
    </p>

    <p>
      IPRE Badge by Charlie Long
      <br />
      <em>
        <a href="https://www.behance.net/gallery/55028055/IPRE-Patch-(2017)">
          https://www.behance.net/gallery/55028055/IPRE-Patch-(2017)
        </a>
      </em>
    </p>

    <p>
      Services icons by The Noun Project
      <br />
      <em>
        <a href="https://thenounproject.com/search/?q=seek&i=1800791">
          https://thenounproject.com/search/?q=seek&i=1800791
        </a>
      </em>
      <em>
        <a href="https://thenounproject.com/search/?q=police&i=1824910">
          https://thenounproject.com/search/?q=police&i=1824910
        </a>
      </em>
      <em>
        <a href="https://thenounproject.com/search/?q=chalice&i=1924542">
          https://thenounproject.com/search/?q=chalice&i=1924542
        </a>
      </em>
    </p>

    <p className="tag center">
      Made with <img src={umbraStaff} alt="" /> by{" "}
      <a href="https://jessesessler.com">Jesse Sessler</a>
    </p>
  </section>
);
